import type { ChildFeePayment } from "../types/parentFamily";
import { createFamilyId } from "./parentFamilyStorage";

export type FeePaymentInput = Omit<
  ChildFeePayment,
  "id" | "createdAt" | "updatedAt"
> & { id?: string };

/** Insert or update a payment in a list, returning a new array. */
export function upsertPaymentInList(
  payments: ChildFeePayment[],
  payment: FeePaymentInput,
  now: string
): ChildFeePayment[] {
  const list = [...payments];
  const idx = payment.id ? list.findIndex((p) => p.id === payment.id) : -1;

  if (idx >= 0) {
    list[idx] = {
      ...list[idx],
      ...payment,
      id: list[idx].id,
      updatedAt: now,
    };
  } else {
    list.push({
      ...payment,
      id: createFamilyId(),
      createdAt: now,
      updatedAt: now,
    });
  }

  return list;
}
